import React from "react";
import FirstHeadingandPara from "../sections/AboutUs/FirstHeadingandPara";
import MeetTheOrigin from "../sections/AboutUs/MeetTheOrigin";
import PeopleMatter from "../sections/AboutUs/PeopleMatter";
import AboutUsBanner from "../components/common/Banners/AboutUsBanner";
import FounderMessage from "../sections/AboutUs/FounderMessage";
import CoFounderMessage from "../sections/AboutUs/CoFounderMessage";
import FullLengthSlider from "../sections/AllServicesSlider/FullLengthSlider";
import OurStory from "../sections/AboutUs/OurStory";
import FeaturesGrid from "../sections/AboutUs/FeaturesGrid";
import WhoWeBuiltFor from "../sections/AboutUs/WhoWeBuiltFor";
import AboutUsFAQs from "../sections/AboutUs/AboutUsFAQs";
import {
  PUBLIC_SECTION_GAP_CLASS,
  PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS,
  PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS,
} from "../sections/Public/shared/publicLayoutSpec";

const AboutUs = () => {
  return (
    <>
      <AboutUsBanner
        headingClasses={
          "text-center text-white"
        }
        heading={"Connecting Australians with Licensed, Qualified, and Verified Tradies"}
        className={"bg-about"}
      />
      
      <OurStory />
      <WhoWeBuiltFor />
      {/* <FeaturesGrid /> */}
      
      {/* <FirstHeadingandPara />
      <FounderMessage />
      <CoFounderMessage />
      <MeetTheOrigin /> */}
      {/* <PeopleMatter /> */}
      <AboutUsFAQs />
      <FullLengthSlider
        className={PUBLIC_SECTION_GAP_CLASS}
        itemGapClassName={PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS}
        labelClassName={PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS}
      />
    </>
  );
};

export default AboutUs;
